import axios from '../axios';
import { useState,useRef } from 'react';
import { URL } from '../urls';
import { coordinatedLoginRequest } from '../../utility/browserLoginCoordinator';

/**
 * Hook for all the api calls to be made before user looged in to the home page i.e dashboard
 * @param {*} url 
 * @param {*} method 
 * @param {*} payload 
 * @returns 
 */

export const useAxios = (url, method, payload) => {
    
    const [responseData, setResponseData] = useState(null);
    const [error, setError] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const controllerRef = useRef(new AbortController());
    
    //this will be used to abort the previous request if any
    const cancel = () => {
      controllerRef.current.abort();
    };
  
    const reset=()=>{
        setLoaded(false);
        setError(null);
        setResponseData(null);
    };

    const executeAPI = async(url,method,payload) => {
        try {
            const requestConfig = {
                data: payload,
                signal: controllerRef.current.signal,
                method,
                url,
              };
            const response =
              url === URL.LOGIN && method === 'POST'
                ? await coordinatedLoginRequest(axios, requestConfig)
                : await axios.request(requestConfig);
              console.log("useAxios success response = ",response.data);
              setResponseData(response.data);
        } catch (error) {
            console.log("useAxios hook, error response ",error);
            setError(error);
        } finally {
            setLoaded(true);
        }
    };
    
   return { cancel,responseData, error, loaded,reset, executeAPI };
  };